var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 439.371 331.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M569.374 461.472V160.658H160.658v300.814h408.716z",
    transform: "translate(-145.33 -145.33)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30.65500069,
    className: "stroke-000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m164.46 164.49 176.32 178.668c13.069 13.17 36.85 13.014 49.643.12l176.199-177.35M170.515 451.566 305.61 313.46M557.968 449.974 426.515 315.375",
    transform: "translate(-145.33 -145.33)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 30.65500069,
    className: "stroke-000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.7caa0b3ea1a8ca3120b75609315eb3d0.svg";
export { ForwardRef as ReactComponent };